import { render, staticRenderFns } from "./iconosWyC.vue?vue&type=template&id=667c122b&"
import script from "./iconosWyC.js?vue&type=script&lang=js&"
export * from "./iconosWyC.js?vue&type=script&lang=js&"
import style0 from "./iconosWyC.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports